import './aox'
import './site.scss'
import './swipeConfig.ts'
import './expandable.ts'
import './scrollToTop.ts'
import Alpine from 'alpinejs';

document.addEventListener("DOMContentLoaded", () => {
    // Initialize Alpine.js
    window.Alpine = Alpine;
    Alpine.start();
});